// extracted by mini-css-extract-plugin
export default {"tag":"EkTDE","yellow":"iPOmL","violet":"QLKv4"};